import {
  Box,
  Checkbox,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import logo from "../../assets/logo/logotest.png";
import prof from '../../assets/images/prof.png'
import cop from '../../assets/images/cop.png'
import {
  Boxflex,
  BoxflexHeader,
  CarInputRegister,
  CarRegister,
  Headder,
  Language,
  Languageres,
  PolicyText,
  CardRegister
} from "./style";
import ButtonCustom from "../../component/button/buttonCustom";
import { useTranslation } from "react-i18next";
import InputTextField from "../../component/input/inputTextField";
import { routeName } from "../../routes/routers-name";
import { colors } from "../../constants/colors";
import AutocompleteSelect from "../../component/select/autoCompleteSelect";
import ReCAPTCHA from "react-google-recaptcha";
import PermMediaIcon from '@mui/icons-material/PermMedia';
/** API */
import InputPasswordField from "../../component/input/inputPasswordField";
import InputDatePicker from "../../component/input/inputDatePicker";
import moment from "moment";
import PrefixApi from "../../api/setting/prefix/prefix.api";
import CustomerCorporationApi from "../../api/customer-corporation/customer-corporation.api";
import { swalError } from "../../component/notification/swal";
import Loading from "../../component/loading/loading";

const initStateErrorMessage = {
  PRFIX_NAME: ``,
  NAME: ``,
  LASTNAME: ``,
  PHONE_NUBER: ``,
  EMAIL: ``,
  USERNAME: ``,
  PASSOWORD: ``,
  CONFIRM_PASSWORD: ``
};

interface RegisterProps {
  onsubmit?: () => void
  onreturn?: () => void
  onModal?: () => void
  firstname?: string
  lastname?: string
  phoneNumber?: string | null
  email?: string | null
  password?: string
  confirmpassword?: string
  refRecaptcha?: any
  checkaccept?: boolean
  prefixOption?: any
  onchangefirstname?: (e: any) => void
  onchangelastname?: (e: any) => void
  onchangephoneNumber?: (e: any) => void
  onchangeemail?: (e: any) => void
  onchangeusername?: (e: any) => void
  onchangecheckaccept?: (e: any) => void
  onchangeRecaptcha?: (value: any) => void
  onchagepassword?: (e: any) => void
  onchangeConfirmpassword?: (e: any) => void
  onchangePrefixId?: (e: any, val: any) => void
  setSendOTP?: any
  setForgetPassword?: any
  setChangePassword?: any
  setOTPType?: any
  setOTPRefer?: any
  setRegister?: any

}

export default function Register(props: RegisterProps) {

  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
  const [type, setType] = useState<string>('')
  const login = () => {
    window.location.href = routeName.login;
  };

  return (
    <CardRegister>
      <BoxflexHeader>
        <Container maxWidth="lg">
          <Headder>
            <Box>
              <img src={logo} alt="Logo" width={160} height={50} />
            </Box>
            <Boxflex>
              {/* <Language>
                <Typography>TH |</Typography>
                <Typography sx={{ marginLeft: "4px" }}>EN</Typography>
              </Language> */}
              <Box>
                <ButtonCustom
                  variant="outlined"
                  textButton={t("REGISTER.BUTTON.LOGIN")}
                  onClick={login}
                  btnStyle={{
                    fontSize: "16px",
                    width: "100%",
                    padding: "8px 25px",
                  }}
                />
              </Box>
              <Box sx={{ marginLeft: "14px" }}>
                <ButtonCustom
                  type="submit"
                  textButton={t("สมัครสมาชิก")}
                  disabled={true}
                  btnStyle={{ fontSize: "16px", width: "100%", padding: "0px" }}
                />
              </Box>
            </Boxflex>
            {/* <Languageres>
              <Typography>TH |</Typography>
              <Typography sx={{ marginLeft: "4px" }}>EN</Typography>
            </Languageres> */}
          </Headder>
        </Container>
      </BoxflexHeader>
      <Box>
        <Container maxWidth="lg" >
          <Box sx={{ paddingTop: "85px" }}>
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: "500",
                textDecoration: "underline",
                textDecorationColor: "green",
              }}
            >
              {t("REGISTER.HEADER.REGISTER")}
            </Typography>
          </Box>
          {type ? <>
            {type === 'CUS' && <>
              <CarRegister>

                <Container maxWidth="lg" style={{ backgroundColor: colors.white }}>
                  <Typography sx={{ fontSize: "18px" }}>
                    {t("REGISTER.HEADER.PERSONAL_CUSTOMER")}
                  </Typography>
                  <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                  <CarInputRegister>
                    <Boxflex>
                      <Grid container spacing={2}>
                        <Grid item lg={4} xs={12} className="w-100">
                          <AutocompleteSelect
                            options={props.prefixOption}
                            getOptionLabel={(option: any) => option.prefixNameTh}
                            onChange={props.onchangePrefixId}
                            labelId="prefix-name"
                            heading={t("REGISTER.INPUT.PREFIX")}
                            required
                            helperText={errorMessage.PREFIX}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12} className="w-100">
                          <InputTextField
                            key="name"
                            value={props.firstname}
                            onchange={props.onchangefirstname}
                            required={true}
                            helperText={errorMessage.NAME}
                            heading={t("REGISTER.INPUT.NAME")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12} className="w-100">
                          <InputTextField
                            key="lastName"
                            value={props.lastname}
                            onchange={props.onchangelastname}
                            helperText={errorMessage.LAST_NAME}
                            required={true}
                            heading={t("REGISTER.INPUT.LAST_NAME")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12} className="w-100">
                          <InputTextField
                            key="phoneNumber"
                            type="number"
                            hideControl
                            value={props.phoneNumber}
                            onchange={props.onchangephoneNumber}
                            required={true}
                            helperText={errorMessage.PHONE_NUBER}
                            inputProps={{
                              maxLength: 10,
                            }}
                            heading={t("REGISTER.INPUT.PHONE_NUMBER")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12} className="w-100">
                          <InputTextField
                            key="email"
                            required={true}
                            value={props.email}
                            onchange={props.onchangeemail}
                            heading={t("REGISTER.INPUT.EMAIL")}
                          />
                        </Grid>
                      </Grid>
                    </Boxflex>
                  </CarInputRegister>
                  <Typography sx={{ fontSize: "18px", marginTop: "40px" }}>
                    {t("REGISTER.HEADER.SET_PASSWORD")}
                  </Typography>
                  <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                  <CarInputRegister>
                    <Grid container spacing={2}>
                      {/* <Grid item lg={4} xs={12} className="w-100">
                    <InputTextField
                      required={true}
                      value={props.username}
                      onchange={props.onchangeusername}
                      heading={t("REGISTER.INPUT.USERNAME")}
                      helperText={errorMessage.USERNAME}
                    />
                  </Grid> */}
                      <Grid item lg={4} xs={12} className="w-100">
                        <InputPasswordField
                          value={props.password}
                          onchange={props.onchagepassword}
                          required={true}
                          helperText={errorMessage.PASSOWORD}
                          heading={t("REGISTER.INPUT.PASSWORD")}
                        />
                      </Grid>
                      <Grid item lg={4} xs={12} className="w-100">
                        <InputPasswordField
                          value={props.confirmpassword}
                          onchange={props.onchangeConfirmpassword}
                          required={true}
                          helperText={errorMessage.CONFIRM_PASSWORD}
                          heading={t("REGISTER.INPUT.CONFIRM_PASSWORD")}
                        />
                      </Grid>
                    </Grid>
                  </CarInputRegister>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                    <ReCAPTCHA
                      ref={props.refRecaptcha}
                      // sitekey="6LdiP1UpAAAAADUyq1e1TahP4w0JFZEgDPCQE7dl"
                      // sitekey="6Lf6ZuImAAAAAL-gXkDymz_tJfzNjw9oHTo595bY"
                      sitekey={process.env.REACT_APP_RECAPTCHA_KEY_FRONT || ''}
                      onChange={props.onchangeRecaptcha}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                    <Checkbox value={props.checkaccept} onChange={props.onchangecheckaccept} />
                    <Box className='d-flex flex-row'>
                      <Typography>ข้าพเจ้ายอมรับข้อกำหนดการใช้งาน รับทราบและตกลงให้มีการเก็บรวบรวมใช้ และเปิดเผยข้อมูลส่วนบุคคลได้ </Typography>
                      <PolicyText className="px-2" onClick={props.onModal}>นโยบายคุ้มครอง</PolicyText>
                    </Box>
                  </Box>
                  <Grid spacing={2} container>
                    <Grid item xs={12} md={6}>
                      <ButtonCustom
                        type="submit"
                        textButton={'กลับ'}
                        onClick={() => {
                          setType('')
                        }}
                        mode='del'
                        btnStyle={{
                          fontSize: "16px",
                          width: "100%",
                          padding: "0px",
                          marginTop: "32px",
                          marginBottom: "14px",
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ButtonCustom
                        type="submit"
                        disabled={props.checkaccept ? false : true}
                        textButton={t("REGISTER.BUTTON.SUMMIT")}
                        onClick={props.onsubmit}
                        btnStyle={{
                          fontSize: "16px",
                          width: "100%",
                          padding: "0px",
                          marginTop: "32px",
                          marginBottom: "14px",
                        }}
                      />
                    </Grid>


                  </Grid>
                </Container>
              </CarRegister>
            </>}
            {type === 'COP' && <>
              <RegisterCop setType={setType}
                setSendOTP={props?.setSendOTP}
                setForgetPassword={props?.setForgetPassword}
                setChangePassword={props?.setChangePassword}
                setOTPType={props?.setOTPType}
                setOTPRefer={props?.setOTPRefer}
                setRegister={props?.setRegister} />
            </>}
          </> : <Box sx={{ width: "100%", justifyContent: "center", display: 'flex', flexDirection: { md: 'row', xs: 'column' }, gap: '10px' }}>
            <img src={prof} alt="pro" style={{ cursor: 'pointer' }} onClick={() => setType('CUS')} />
            <img src={cop} alt="cop" style={{ cursor: 'pointer' }} onClick={() => setType('COP')} />
          </Box>}

        </Container>
      </Box>
    </CardRegister>
  );
}

const initErrorMessage = {

};
type REGISTER_COP = {
  email: string
  firstname: string,
  // mobilePhone: string,
  password: string,
  reCaptcha: string,
  taxId: string,
  corporat_type: string,
  prefixId: number,
  hier_firstname: string,
  hier_lastname: string,
  position_name: string,
  idCard: string,
  birthDay: string,
  hier_mobile: string,
  hier_email: string
}

const RegisterCop = (props: any) => {
  const { setType, setSendOTP, setForgetPassword, setChangePassword, setOTPType, setOTPRefer, setRegister } = props

  const uploadRefs = useRef<HTMLInputElement[]>([]);
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<any>(initErrorMessage);
  const [form, setForm] = useState<REGISTER_COP>({
    email: '',
    firstname: '',
    // mobilePhone: '123',
    password: '',
    reCaptcha: '',
    taxId: '',
    corporat_type: '',
    prefixId: 0,
    hier_firstname: '',
    hier_lastname: '',
    position_name: '',
    idCard: '',
    birthDay: '',
    hier_mobile: '',
    hier_email: ''
  });
  const [loading, setLoading] = useState<boolean>(false);

  const [checkAccept, setCheckAccept] = useState<boolean>(false);
  const [c_pass, setC_Pass] = useState<string>("");
  const [files, setFiles] = useState<any[]>([]);
  const recaptchaRef: any = useRef(null);

  const [prefixOption, setPrefixOption] = useState<any[]>([]);
  const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);

  const getPrefixes = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 10,
      status: "ACTIVE"
    };
    const res = await PrefixApi.findAll(condition);
    setPrefixOption(res.data);
  };

  useEffect(() => {
    getPrefixes();
  }, []);

  const handleImportFileItem = async (id: any, obj: any, index: number) => {
    const file = obj
    const formData: FormData = new FormData();
    formData.append('file', file)
    formData.append('document_type', 'หนังสือรับรองนิติบุคคล')

    if (file) {
      await CustomerCorporationApi.register_file(id, formData).then((res) => {
        if (res.status < 300) {

          // alertSuccess("นำเข้าไฟล์", "นำเข้าไฟล์ เรียบร้อย", undefined, () => {
          //     window.location.reload()
          // })
        } else {
          // alertError("นำเข้าไฟล์", "นำเข้าไฟล์ ไม่สำเร็จ")
        }
        if (uploadRefs.current[index]) {
          uploadRefs.current[index].value = "";
        }
      }).catch((err) => {
        console.log(err);
        // alertError(err?.response?.data?.message || "นำเข้าไฟล์ ไม่สำเร็จ");
        if (uploadRefs.current[index]) {
          uploadRefs.current[index].value = "";
        }
      }).finally(() => {
      })
    } else {
      return false;
    }
  }
  const handleSubmit = async () => {
    if (!form?.taxId)
      return setErrorMessage({
        ...errorMessage,
        ...{ taxId: 'ระบุเลขประจำตัวผู้เสียภาษี' },
      });

    if (!form?.corporat_type)
      return setErrorMessage({
        ...errorMessage,
        ...{ corporat_type: 'ระบุสถานะนิติบุคคล' },
      });
    if (!form?.firstname)
      return setErrorMessage({
        ...errorMessage,
        ...{ firstname: 'ระบุชื่อนิติบุคคล' },
      });
    if (!form?.prefixId)
      return setErrorMessage({
        ...errorMessage,
        ...{ prefixId: 'ระบุคำนำหน้า' },
      });
    if (!form?.hier_firstname)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_firstname: 'ระบุชื่อ' },
      });
    if (!form?.hier_lastname)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_lastname: 'ระบุนามสกุล' },
      });
    if (!form?.position_name)
      return setErrorMessage({
        ...errorMessage,
        ...{ position_name: 'ระบุตำแหน่ง' },
      });
    if (!form?.idCard)
      return setErrorMessage({
        ...errorMessage,
        ...{ idCard: 'ระบุเลขบัตรประชาชน' },
      });
    if (!form?.birthDay)
      return setErrorMessage({
        ...errorMessage,
        ...{ birthDay: 'ระบุวัน /เดือน /ปีเกิด' },
      });
    if (!form?.hier_mobile)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_mobile: 'ระบุเบอร์โทรศัพท์มือถือ' },
      });
    if (!form?.hier_email)
      return setErrorMessage({
        ...errorMessage,
        ...{ hier_email: 'ระบุอีเมล' },
      });
    if (!form?.email)
      return setErrorMessage({
        ...errorMessage,
        ...{ email: 'ระบุอีเมล' },
      });
    if (!form?.password)
      return setErrorMessage({
        ...errorMessage,
        ...{ password: 'ระบุรหัสผ่าน' },
      });
    if (!c_pass)
      return setErrorMessage({
        ...errorMessage,
        ...{ c_pass: 'ระบุรหัสผ่าน' },
      });
    if (form?.password !== c_pass)
      return setErrorMessage({
        ...errorMessage,
        ...{ password: 'รหัสผ่านไม่ตรงกะน' },
      });
    if (files?.length === 0)
      return swalError('กรุณาเพิ่มหนังสือรับรองนิติบุคคล')

    const body = form
    setLoading(true)
    await CustomerCorporationApi.register(body).then(async (res: any) => {
      if (res.data) {
        const x = files?.filter((item: any) => item?.name)

        if (x?.length > 0) {
          for (let index = 0; index < x.length; index++) {
            handleImportFileItem(res.data.data.customerId, x[index], index)
          }
        }
        setLoading(false)
        setSendOTP(true);
        setForgetPassword(false);
        setChangePassword(false);
        setOTPType("REGISTER");
        setOTPRefer(res.data.data.otpRefer);
        setRegister(false);
      }

    })
      .catch((error) => {
        console.log(error?.response);
        swalError(error?.response?.data?.errorDescription);

        setLoading(false)

      });
  }
  return (
    <>
      <CarRegister>

        <Container maxWidth="lg" style={{ backgroundColor: colors.white }}>
          <Typography sx={{ fontSize: "18px" }}>
            {t("REGISTER.HEADER.PERSONAL_CUSTOMER")}
          </Typography>
          <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          <CarInputRegister>
            <Boxflex>
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField

                    value={form?.taxId}
                    onchange={(e) => {
                      setForm({ ...form, taxId: e.target.value })
                      clearErrorMessage()
                    }}
                    required={true}
                    helperText={errorMessage.taxId}
                    inputProps={{
                      maxLength: 13,
                    }}
                    heading={t("เลขประจำตัวผู้เสียภาษี")}
                  />
                </Grid>
                <Grid item lg={4} xs={12} className="w-100">
                  <AutocompleteSelect
                    options={['บริษัทจำกัด', 'บริษัทจำกัด(มหาชน)', 'ห้างหุ้นส่วนจำกัด', 'ห้างหุ้นส่วนสามัญ(จดทะเบียน)', 'กลุ่มเกษตรกร','สหกรณ์','สมาคมกลุ่มแม่บ้านเกษตรกร']}
                    getOptionLabel={(option: any) => option}
                    onChange={(e, val) => {
                      setForm({ ...form, corporat_type: val })
                      clearErrorMessage()
                    }}
                    value={form?.corporat_type}
                    labelId="prefix-name"
                    heading={t("สถานะนิติบุคคล")}
                    required
                    helperText={errorMessage.corporat_type}
                  />
                </Grid>
                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    value={form?.firstname}
                    onchange={(e) => {
                      setForm({ ...form, firstname: e.target.value })
                      clearErrorMessage()
                    }}
                    helperText={errorMessage.firstname}
                    required={true}
                    heading={t("ชื่อนิติบุคคล")}
                  />
                </Grid>


              </Grid>
            </Boxflex>
          </CarInputRegister>
          <Typography sx={{ fontSize: "18px", marginTop: "40px" }}>
            {t("ผู้ติดต่อ")}
          </Typography>
          <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          <CarInputRegister>
            <Boxflex>
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12} className="w-100">
                  <AutocompleteSelect
                    options={prefixOption}
                    getOptionLabel={(option: any) => option?.prefixNameTh}
                    onChange={(e, value) => {
                      setForm({ ...form, prefixId: value?.prefixId })
                      clearErrorMessage()
                    }}
                    value={prefixOption?.find((item: any) => item?.prefixId === form?.prefixId) || null}
                    labelId="prefix-name"
                    heading={t("REGISTER.INPUT.PREFIX")}
                    required
                    helperText={errorMessage?.prefixId || ''}
                  />
                </Grid>
                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    key="name"
                    value={form?.hier_firstname}
                    onchange={(e) => {
                      setForm({ ...form, hier_firstname: e.target.value })
                      clearErrorMessage()
                    }}
                    required={true}
                    helperText={errorMessage?.hier_firstname || ''}
                    heading={t("REGISTER.INPUT.NAME")}
                  />
                </Grid>
                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    key="lastName"
                    value={form?.hier_lastname}
                    onchange={(e) => {
                      setForm({ ...form, hier_lastname: e.target.value })
                      clearErrorMessage()
                    }}
                    helperText={errorMessage?.hier_lastname || ''}
                    required={true}
                    heading={t("REGISTER.INPUT.LAST_NAME")}
                  />
                </Grid>
                <Grid item xs={12} className="w-100">
                  <AutocompleteSelect
                    options={['กรรมการ/ผู้มีอำนาจ', 'พนักงาน/ตัวแทน']}
                    getOptionLabel={(option: any) => option}
                    value={form?.position_name}
                    onChange={(e, value) => {
                      setForm({ ...form, position_name: value })
                      clearErrorMessage()
                    }}
                    labelId="prefix-name"
                    heading={t("ตำแหน่ง")}
                    required
                    helperText={errorMessage?.position_name || ''}
                  />
                </Grid>
                <Grid item lg={5} xs={12} className="w-100">
                  <InputTextField

                    value={form?.idCard}
                    onchange={(e) => {
                      setForm({ ...form, idCard: e.target.value })
                      clearErrorMessage()
                    }}
                    required={true}
                    helperText={errorMessage?.idCard || ''}
                    inputProps={{
                      maxLength: 13,
                    }}
                    heading={t("เลขบัตรประชาชน")}
                  />
                </Grid>
                <Grid item lg={5} xs={12} className="w-100">
                  {/* <InputTextField
                  key="phoneNumber"
                  type="number"
                  hideControl
                  value={props.phoneNumber}
                  onchange={props.onchangephoneNumber}
                  required={true}
                  helperText={errorMessage.PHONE_NUBER}
                  inputProps={{
                    maxLength: 10,
                  }}
                  heading={t("วัน /เดือน /ปีเกิด*")}
                /> */}
                  <InputDatePicker value={form?.birthDay} onChange={function (val: any): void {
                    setForm({ ...form, birthDay: moment(val).format('YYYY-MM-DD') })
                    clearErrorMessage()
                  }} heading="วัน /เดือน /ปีเกิด" helperText={errorMessage?.birthDay || ''} />
                </Grid>
                <Grid item lg={2} xs={12} className="w-100">
                  <InputTextField

                    value={form?.birthDay ? new Date().getFullYear() - new Date(form?.birthDay).getFullYear() : ''}
                    disabled

                    heading={t("อายุ")}
                  />
                </Grid>
                <Grid item lg={6} xs={12} className="w-100">
                  <InputTextField
                    value={form?.hier_mobile}
                    onchange={(e) => {
                      setForm({ ...form, hier_mobile: e.target.value })
                      clearErrorMessage()
                    }}
                    required={true}
                    helperText={errorMessage.hier_mobile || ''}
                    inputProps={{
                      maxLength: 10,
                    }}
                    heading={t("REGISTER.INPUT.PHONE_NUMBER")}
                  />
                </Grid>
                <Grid item lg={6} xs={12} className="w-100">
                  <InputTextField
                    key="email"
                    required={true}
                    value={form?.hier_email}
                    onchange={(e) => {
                      setForm({ ...form, hier_email: e.target.value })
                      clearErrorMessage()
                    }}
                    heading={t("REGISTER.INPUT.EMAIL")}
                    helperText={errorMessage.hier_email || ''}
                  />
                </Grid>
              </Grid>
            </Boxflex>
          </CarInputRegister>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
            <Typography sx={{ fontSize: "18px", marginTop: "40px" }}>
              หนังสือรับรองนิติบุคคล <span style={{ fontSize: '14px', color: 'red' }}>(คัดรับรองไม่เกิน 6 เดือน) *</span>
            </Typography>
            <ButtonCustom
              type="submit"
              textButton={'เพิ่ม'}
              onClick={() => {
                setFiles([...files, {}])
              }}
              style={{ margin: '0px' }}
              btnStyle={{
                fontSize: "16px",
                width: "100%",
                padding: "0px",
                margin: '0px'
              }}
            />
          </div>

          <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          <div style={{ display: "flex", flexDirection: 'column', gap: '10px' }}>
            {files?.map((item: any, index: number) => {
              return (
                <div key={index}
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px', border: '1px solid #D9D9D9', borderRadius: '8px' }}>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <PermMediaIcon style={{ color: colors.themeMainColor, fontSize: "48px" }} />
                    {item?.name || 'เลือกไฟล์'}
                  </div>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {!item?.name ? <ButtonCustom mode='add' textButton={'เลือก'} onClick={() => uploadRefs.current[index]?.click()} style={{ margin: '0px' }} /> : <ButtonCustom mode={'del'} textButton={'ลบไฟล์'} onClick={() => setFiles((pre) =>
                      pre.map((p, i) =>
                        i === index ? {} : p
                      )
                    )} style={{ margin: '0px' }} />}
                    <ButtonCustom mode={'del'} textButton={'ลบ'} onClick={() => setFiles(files?.filter((item, i) => i !== index))} style={{ margin: '0px' }} /></div>
                  <input type='file' ref={(el) => (uploadRefs.current[index] = el!)}
                    onChange={(e: any) => setFiles((pre) =>
                      pre.map((p, i) =>
                        i === index ? e.target.files[0] : p
                      )
                    )} style={{ display: 'none' }} />
                </div>
              )
            })}
          </div>

          <Typography sx={{ fontSize: "18px", marginTop: "40px" }}>
            {t("ตั้งค่ารหัสผ่าน")}
          </Typography>
          <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          <CarInputRegister>
            <Boxflex>
              <Grid container spacing={2}>

                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    key="name"
                    value={form?.email}
                    onchange={(e) => {
                      setForm({ ...form, email: e.target.value })
                      clearErrorMessage()
                    }}
                    required={true}
                    helperText={errorMessage.email || ''}
                    heading={t("อีเมล")}
                  />
                </Grid>

                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    key="lastName"
                    value={form?.password}
                    onchange={(e) => {
                      setForm({ ...form, password: e.target.value })
                      clearErrorMessage()
                    }}
                    type="password"
                    helperText={errorMessage.password || ''}
                    required={true}
                    heading={t("รหัสผ่าน")}
                  />
                </Grid>
                <Grid item lg={4} xs={12} className="w-100">
                  <InputTextField
                    key="lastName"
                    value={c_pass}
                    onchange={(e) => {
                      setC_Pass(e.target.value)
                    }}
                    onblur={(e) => {
                      if (e.target.value !== form?.password) {
                        setErrorMessage({ ...errorMessage, c_pass: 'รหัสผ่านไม่ตรงกัน' })
                        clearErrorMessage()
                      }
                    }}
                    helperText={errorMessage.c_pass}
                    required={true}
                    type="password"
                    heading={t("ยืนยันรหัสผ่าน")}
                  />
                </Grid>

              </Grid>
            </Boxflex>
          </CarInputRegister>
          <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
            <ReCAPTCHA
              ref={recaptchaRef}
              // sitekey="6Lf6ZuImAAAAAL-gXkDymz_tJfzNjw9oHTo595bY" // dev
              // sitekey="6LdiP1UpAAAAADUyq1e1TahP4w0JFZEgDPCQE7dl" // pro
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY_FRONT || ''}

              onChange={(value) => setForm({ ...form, reCaptcha: value || '' })}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
            <Checkbox checked={checkAccept} onChange={(e) => setCheckAccept(e.target.checked)} />
            <Box className='d-flex flex-row'>
              <Typography>ข้าพเจ้ายอมรับข้อกำหนดการใช้งาน รับทราบและตกลงให้มีการเก็บรวบรวมใช้ และเปิดเผยข้อมูลส่วนบุคคลได้ </Typography>
              <PolicyText className="px-2" onClick={props.onModal}>นโยบายคุ้มครอง</PolicyText>
            </Box>
          </Box>
          <Grid spacing={2} container>
            <Grid item xs={12} md={6}>
              <ButtonCustom
                type="submit"
                textButton={'กลับ'}
                onClick={() => {
                  setType('')
                }}
                mode='del'
                btnStyle={{
                  fontSize: "16px",
                  width: "100%",
                  padding: "0px",
                  marginTop: "32px",
                  marginBottom: "14px",
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <ButtonCustom
                type="submit"
                disabled={!checkAccept || !form?.reCaptcha}
                textButton={t("REGISTER.BUTTON.SUMMIT")}
                onClick={() => {
                  handleSubmit()
                }}
                btnStyle={{
                  fontSize: "16px",
                  width: "100%",
                  padding: "0px",
                  marginTop: "32px",
                  marginBottom: "14px",
                }}
              />
            </Grid>


          </Grid>
        </Container>

      </CarRegister>
      {loading && <Loading show={loading} type="fullLoading" />}
    </>
  )
}